import {
	VISIT_SET_CURRENT_FILTERS,
	VISIT_SET_PAGINATION,
	VISIT_SET_VISITS,
	VISIT_GET_DYNAMIQUE_FILTER_VALUES,
	VISIT_SET_SORT,
	VISIT_SET_KEY_FILTER_SELECTED,
} from "./../types";

function action(type, payload = {}) {
	return { type, ...payload };
}

export const setVisits = visits => action(VISIT_SET_VISITS, visits);

export const init = () => {
	return (dispatch, getState) => {
		const state = getState();
		dispatch(setPagination(1, state.visit.pages));
	};
};

export const getVisits = data => {
	return (dispatch, getState) => {
		const state = getState();
		dispatch(setPagination(data.page, state.visit.pages));
	};
};

export const setSort = (columnKey, sortOrder) => {
	return action(VISIT_SET_SORT, columnKey, sortOrder);
};

export const setPagination = (page, pages) => ({
	type: VISIT_SET_PAGINATION,
	page,
	pages,
});

export const setCurrentFilters = currentFilters => ({
	type: VISIT_SET_CURRENT_FILTERS,
	currentFilters,
});

export function updateFiltersDate(key, filters) {
	return (dispatch, getState) => {
		const state = getState();

		const currentFilters = state.visit.currentFilters || {};

		if (filters) {
			currentFilters[key] = filters;
		} else {
			delete currentFilters["sector_label"]; // Remove current filters when date is unselected
			delete currentFilters["retailer_label"];
			delete currentFilters["pdc_label"];
			delete currentFilters["startDate"];
			delete currentFilters["endDate"];
		}
		dispatch(setCurrentFilters(currentFilters));
		dispatch(getVisits({ filters: currentFilters, page: 1 }));
	};
}

export function updateFiltersFront(key, filters) {
	return (dispatch, getState) => {
		const state = getState();
		const currentFilters = state.visit.currentFilters || {};
		if (filters && (filters.length && filters.length !== 0)) {
			currentFilters[key] = filters;
		} else {
			delete currentFilters[key];
		}
		if (key === "surveyId") {
			delete currentFilters["sector_label"]; // Remove current filters when surveyId is unselected
			delete currentFilters["retailer_label"];
			delete currentFilters["pdc_label"];
		}

		dispatch(setCurrentFilters(currentFilters));
		dispatch(getVisits({ filters: currentFilters, page: 1 }));
	};
}
export const setKeyFilterSelected = key => ({
	type: VISIT_SET_KEY_FILTER_SELECTED,
	key,
});
export function getDynFilterValues(key) {
	return action(VISIT_GET_DYNAMIQUE_FILTER_VALUES, key);
}



// WEBPACK FOOTER //
// src/redux/actions/visitActions.js